import React from 'react'
import { Link, NavLink } from "react-router-dom";

import { FaCheck } from "react-icons/fa6";
import about from '../../assets/Images/about.png'
import CountUp from 'react-countup';

function AboutUs() {
    return (
        <div className='about'>
            <div className="container">
                <div className="row">
                     <div className="col-lg-6 col-md-6">    {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300" */}
                        <div className="d-flex gap-3 align-items-center">
                            <hr className='hr3' />
                            <h3 className='heading1'>About Us</h3>
                        </div>
                        <h2>
                            Explore Our Services And Boost Your Online Presence
                        </h2>
                        <p>
                        Our software solutions are designed to elevate your business in a digital-first world. From custom application development to cloud integration, we provide cutting-edge technology to streamline your operations and maximize your growth. With years of industry experience and a team of dedicated experts, we’re committed to delivering reliable, scalable, and innovative solutions.
                        </p>    
                        <div className="d-flex align-items-center gap-4 mt-4">
                            <FaCheck className='check' style={{ color: ' #fa982f' }} />
                            <h5>Customized software to meet unique business needs and drive efficiency.</h5>
                        </div>
                        <div className="d-flex align-items-center gap-4 mt-4">
                            <FaCheck className='check' style={{ color: ' #fa982f' }} />
                            <h5>End-to-end support for digital transformation and future-ready solutions.</h5>
                        </div>
                        <div className="d-flex gap-lg-4 gap-md-2 gap-sm-4 gap-2 mt-4">
                            <Link to = "/service" className="btn_1">Get Started</Link>
                            <Link to = "/About" className="btn_2">Discover More</Link>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 d-flex align-items-center justify-content-center position-relative" > {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1300" */}
                        <div className="about-mask">
                            <figure>
                                <img src={about} alt="about.img" />
                            </figure>
                        </div>
                        <div className="about-count d-flex flex-column align-items-center justify-content-center text-center">
                            <div className="d-flex align-items-center justify-content-center">
                                <h2 className='m-0'> <CountUp start ={0} end ={12} duration ={3} delay ={2} /> </h2>
                                <h2 className='m-0'>+</h2>
                            </div>
                            <p className='m-0'>Years of Experience</p>
                        </div>
                        <div className="about-hr d-flex align-items-center justify-content-center gap-3">
                            <hr />
                            <h6>Who We are</h6>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AboutUs
